<template>
  <div>
    <b-card header="Preview">
      <b-container fluid>
        <div class="preview-bg d-flex flex-column align-items-center">
          <b-img
            class="logo"
            src="/img/mlb-logo-text.png"
            alt="MLB" />

          <header>{{ config.header || placeholder.header }}</header>
          <h4
            v-if="config.subheader"
            class="m-0">
            {{ config.subheader || placeholder.subheader }}
          </h4>

          <b-container class="d-flex justify-content-center w-100 mt-4 p-0">
            <div
              v-for="pkg in enabledPkgs"
              :key="`${pkg.title}-${device}`">
              <div
                class="tile-wrap flex-column align-content-between h-100">
                <p
                  class="p-0 font-weight-bold mb-1"
                  style="font-size: 18px">
                  {{ pkg.title || placeholder.title }}
                </p>
                <p
                  id="price"
                  class="p-0">
                  {{ pkg.price || placeholder.price }}
                </p>
                <p
                  id="text"
                  class="p-0 mb-5">
                  {{ pkg.text || placeholder.text }}
                </p>
                <b-container
                  class="d-flex flex-column p-0"
                  style="font-size: 18px;">
                  <div
                    v-for="(button, i) in pkg.buttons"
                    :key="`${device}-${i}-btn`">
                    <div
                      v-if="button.enabled"
                      class="paywall-btn mb-2 pt-1 pb-1">
                      {{ button.text }}
                    </div>
                  </div>
                </b-container>
              </div>
            </div>
          </b-container>
        </div>
      </b-container>
    </b-card>
    <hr style="border-top: 2px solid rgba(0, 0, 0, 0.1)">
  </div>
</template>

<script>
export default {
  name: "PaywallPreview",

  props: {
    config: {
      type: Object,
      default: null,
      required: true,
    },
    device: {
      type: String,
      default: null,
      required: true,
    },
    placeholder: {
      type: Object,
      default: null,
      required: true,
    },
  },
  computed: {
    enabledPkgs() {
      return this.config.packages.filter(pkg => pkg.enabled && pkg.buttons.filter(btn => btn.enabled))
    },
  },


}
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Roboto&display=swap");

.card-body, .container-fluid {
  font-family: "Roboto", sans-serif;
  color: white;
  padding: 0;
}

.card-body > .container-fluid, h4 {
  color: white;
}

.logo {
  margin-top: 30px;
  width: 200px;
  height: auto;
}

.preview-bg {
  margin: 0 auto;
  height: 540px;
  background: no-repeat url("//cd-images.mlbstatic.com/common/backgrounds/fhd/147-dark.jpg");
  background-size: cover;
}

header {
  font-size: 30px;
  font-weight: normal;
  letter-spacing: 1px;
  margin-top: 25px;
}

.tile-wrap {
  width: 325px;
  margin: 0 5px;
  font-size: 15px;
  border-radius: 8px;
  padding: 12px 12px 17px;
  background-image: linear-gradient(to bottom, #272727, #111);
}

.paywall-btn {
  letter-spacing: 1px;
  border-radius: 8px;
  text-align: center;
  border: solid 1.8px #888;
  box-shadow: 0 0 8px 0 #000;
}

.paywall-btn:hover {
  font-weight: bold;
  cursor: pointer;
  color: black;
  background-color: #ddd;
  transform: scale(1.07);
  transition: all 0.1s ease-in-out;
}
</style>
